import styled from 'styled-components'
import {device} from '../../../theme'

export const AssuranceWrap = styled.div `
    padding-top: 60px;
    padding-bottom: 60px;
    @media ${device.medium}{
        padding-top: 60px;
    }
    @media ${device.small}{
        padding-top: 60px;
    }
`;

export const ImageWrap = styled.div `
    text-align: right;
    @media ${device.medium}{
        display:none;
    }
`;

export const CaseStudyTextWrap = styled.div `
    max-width: 500px;
    width: 100%;
    margin: auto;
`;

export const ButtonWrap = styled.div `
    margin-top: 34px;
`;
